import type { EventSettableColumnId } from '@features/event-level-column-rename/types';

export type ColumnAudience = 'buyer_defined' | 'calculated' | 'supplier_entered';

/**
 * Who provides each renameable column's value, proven from the supplier quote grid
 * (`QuoteSubmission/Lots/LineItemsTable/utils/initialColumnSettings.tsx`): a column the supplier
 * can edit there (`readOnly: isReadOnly`) is supplier-entered; a quote total (`quote.total`,
 * `quote.additional_fees`, `quote.all_in_price`) is calculated; the rest are line-item fields the
 * buyer sets. With Collect Items Per Unit on, Quantity of Items (`li.extended_quantity`) is the
 * buyer's input and Quantity of Units (`li.quantity_of_units`) is derived from it by
 * `calculateQuantityOfUnits`; without it, Quantity of Units is the buyer's direct input. In neither
 * case is either quantity a quote value, so both are buyer-defined.
 */
export const COLUMN_AUDIENCE: Record<EventSettableColumnId, ColumnAudience> = {
  discountPerUnit: 'supplier_entered',
  itemsPerUnit: 'supplier_entered',
  lineItemName: 'buyer_defined',
  lineItemPrice: 'calculated',
  pricePerUnit: 'supplier_entered',
  quantityOfItems: 'buyer_defined',
  quantityOfUnits: 'buyer_defined',
  quotedQuantityOfUnits: 'supplier_entered',
  suggestedPricePerUnit: 'buyer_defined',
  totalAdditionalCosts: 'calculated',
  totalAllInPrice: 'calculated',
  unitOfMeasure: 'buyer_defined',
};

export const columnAudienceHintKey = (columnId: EventSettableColumnId): string => (
  `bid_request.event_config_menu.column_labels.audience_hints.${COLUMN_AUDIENCE[columnId]}`
);
